export const loadingStore = {
  namespaced: true,
  state: {
    isGlobalLoading: false,
    progress: null,
    activeCount: 0,
  },
  mutations: {
    INCREMENT(state) {
      state.activeCount++
      state.isGlobalLoading = true
    },
    DECREMENT(state) {
      state.activeCount = Math.max(0, state.activeCount - 1)
      state.isGlobalLoading = state.activeCount > 0
      if (!state.isGlobalLoading) state.progress = null
    },
    SET_PROGRESS(state, payload) {
      state.progress = payload
    },
  },
  actions: {
    show({ commit }, payload = {}) {
      commit('INCREMENT')
      if (payload.progress != null) commit('SET_PROGRESS', payload.progress)
    },
    hide({ commit }) {
      commit('DECREMENT')
    },
    setProgress({ commit }, progress) {
      commit('SET_PROGRESS', progress)
    },
  }
}
